import { RoundedMathSymbol } from "shared/app/VerificationTemplate/components/RoundedMathSymbol";
import { Show } from "shared/components";
import { toMoney } from "shared/utils";
import { Money } from "types/landlord/reports";
import { VerifiedBadge } from "shared/components/VerifiedBadge";

export const ProjectedDebtToIncome = ({
  totalMonthlyDebt,
  monthlyIncome,
  monthlyIncomeLabel,
  debtToIncomeRatio,
  debtToIncomeRatioLabel,
  isVerified
}: {
  totalMonthlyDebt: Money;
  monthlyIncome: number;
  monthlyIncomeLabel: string;
  debtToIncomeRatio?: number | null;
  debtToIncomeRatioLabel: string;
  isVerified?: boolean;
}) => {
  return (
    <div className="flex md:flex-row flex-col gap-y-2 w-full items-center gap-6">
      <div className="flex md:flex-col text-sm gap-2 mr-4">
        <p className="text-content-1000 font-medium">Monthly debt</p>
        <p className="text-content-300 font-medium md:text-left text-center">
          {toMoney(totalMonthlyDebt.cents / 100)}
        </p>
      </div>

      <RoundedMathSymbol symbol="/" />
      <div className="flex md:flex-col md:w-[230px] gap-2 text-sm mx-4">
        <p className="text-content-1000 font-medium">{monthlyIncomeLabel}</p>
        <p className="text-content-300 md:text-left text-center">
          {toMoney(monthlyIncome)}
        </p>
      </div>

      <RoundedMathSymbol symbol="X" />

      <p className="text-content-1000 font-medium md:text-left text-center text-sm mx-4">
        100
      </p>

      <RoundedMathSymbol symbol="=" />

      <div className="flex md:flex-col md:w-[170px] gap-2 text-sm ml-4">
        <p className="text-content-1000 font-medium">
          {debtToIncomeRatioLabel}
        </p>
        <p className="text-content-300 font-medium md:text-left text-center">
          {debtToIncomeRatio || 0}%
        </p>
        <Show if={isVerified}>
          <VerifiedBadge />
        </Show>
      </div>
    </div>
  );
};
